import { Box, Center } from '@chakra-ui/react'
import { Icon, Image } from '@core/ui-elements'
import { LoadingComponent } from '@ui-components/loading-component'
import { CSSProperties, useState } from 'react'
import { MdOutlineImage } from 'react-icons/md'

type FallbackImageErrorProps = {
  imageUrl?: string | null
  alt: string
  size?: string
  style?: CSSProperties
  height?: string
  iconSize?: string
}

export const FallbackImageError = ({
  imageUrl,
  alt,
  size = '4rem',
  height = '100%',
  iconSize = '100%',
  style,
}: FallbackImageErrorProps) => {
  const [hasError, setHasError] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  if (hasError || !imageUrl) {
    return (
      <Center h={height} w="100%">
        <Icon
          as={MdOutlineImage}
          borderRadius={'0.25rem'}
          color="gray.500"
          fontSize={size}
          height={iconSize}
          margin="auto"
        />
      </Center>
    )
  }

  return (
    <Box h={height} position="relative" w={style?.width ?? '100%'}>
      {isLoading && (
        <Center inset={0} position="absolute">
          <LoadingComponent />
        </Center>
      )}
      <Center inset={0} position="absolute">
        <Image
          alt={alt}
          src={imageUrl}
          style={style}
          onError={() => {
            setIsLoading(false)
            setHasError(true)
          }}
          onLoad={() => setIsLoading(false)}
        />
      </Center>
    </Box>
  )
}
